var _path, _path2, _rect, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLumenLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1191,
    height: 555,
    viewBox: "0 0 1191 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.172 306.615V0.185547H172.047V383.07H476.607V306.615H250.172Z",
    fill: "#042830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M848.974 0.185547L719.624 289.26L589.283 0.185547H476.611V307.003H550.27L547.093 64.9095H548.086L684.78 372.647H751.49L889.277 64.9095H890.27L887.093 383.07H960.752V0.185547H849.073H848.974Z",
    fill: "#042830"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 172.047,
    y: 430.798,
    width: 78.1858,
    height: 123.488,
    fill: "#08C1D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 124.324,
    y: 304.891,
    width: 78.1858,
    height: 123.488,
    transform: "rotate(90 124.324 304.891)",
    fill: "#08C1D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.69 330.19H1062.4C1076.35 330.19 1079.7 321.874 1079.7 315.033C1079.7 305.912 1074.2 299.742 1062.8 299.742H1022.69V330.19ZM1008.47 383.172V287.402H1067.76C1086.94 287.402 1093.92 300.681 1093.92 312.887C1093.92 324.691 1088.42 333.141 1077.82 336.494V336.762C1086.41 337.97 1091.23 345.883 1091.77 357.151C1092.44 374.856 1093.25 379.685 1096.33 383.172H1081.31C1079.03 380.49 1079.03 376.331 1078.36 364.93C1077.28 347.761 1071.65 342.53 1059.85 342.53H1022.69V383.172H1008.47Z",
    fill: "#042830"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.19 324.288L1172.36 287.402H1189.93L1153.04 334.08L1191 383.172H1172.36L1143.38 344.408L1114.54 383.172H1096.84L1134.66 334.08L1098.72 287.402H1116.83L1144.19 324.288Z",
    fill: "#042830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumenLogoIcon);
export default __webpack_public_path__ + "static/media/lumen-logo-icon.dea44075a3a156391b1c0780f8d99691.svg";
export { ForwardRef as ReactComponent };